// The directories a startup was matched to, with what to enter on each, and the team's own answers;
// Venturz also checks each directory's form and switches each directory on or off.
class StartupDirectories {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/search-visibility/startup-directories`;
    this.apiClient = apiClient;

  }

  async getDirectories(paginationOptions, filterOptions) {

    const path = this.basePath;

    return this.apiClient.get(path, {}, { paginationOptions, filterOptions: filterOptions || {} });

  }

  async answerField(submissionId, answer) {

    const path = `${this.basePath}/${submissionId}/answers`;

    return this.apiClient.put(path, {}, {}, answer);

  }

  async setEnabled(directoryId, payload) {

    const path = `${this.basePath}/${directoryId}/enabled`;

    return this.apiClient.put(path, {}, {}, payload);

  }

  async setSubmissionURL(directoryId, payload) {

    const path = `${this.basePath}/${directoryId}/submission-url`;

    return this.apiClient.put(path, {}, {}, payload);

  }

  async setPlatformURL(directoryId, payload) {

    const path = `${this.basePath}/${directoryId}/platform-url`;

    return this.apiClient.put(path, {}, {}, payload);

  }

  async review(directoryId) {

    const path = `${this.basePath}/${directoryId}/review`;

    return this.apiClient.put(path, {}, {}, {});

  }

  async reread(directoryId) {

    const path = `${this.basePath}/${directoryId}/reread`;

    return this.apiClient.post(path, {}, {}, {});

  }

  async readScreenshots(directoryId, imageURLs, fileIds) {

    const path = `${this.basePath}/${directoryId}/screenshots`;

    return this.apiClient.post(path, {}, {}, { imageURLs, fileIds });

  }

  async draftFields(submissionId) {

    const path = `${this.basePath}/${submissionId}/drafts`;

    return this.apiClient.post(path, {}, {}, {});

  }

  async readSentPage(directoryId, page) {

    const path = `${this.basePath}/${directoryId}/page`;

    return this.apiClient.post(path, {}, {}, page);

  }

}

export default StartupDirectories;
